import * as React from "react";
const EnvelopeOpen = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { clipPath: "url(#prefix__a)" },
        React.createElement("mask", { id: "prefix__b", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
                maskType: "luminance",
            } },
            React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
        React.createElement("g", { mask: "url(#prefix__b)" },
            React.createElement("path", { fill: "#CFCFCF", d: "M95.5 48H.5v47.5h95z" }),
            React.createElement("path", { fill: "#3F3F3F", d: "M48 95.5 95.5 48H.5z" }),
            React.createElement("path", { fill: "#ED0000", d: "M48 .5.5 48h95z" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "prefix__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h96v96H0z" })))));
export default EnvelopeOpen;
//# sourceMappingURL=EnvelopeOpen.js.map